import { ApolloClient } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { useAuth } from 'common-react/auth/AuthProvider';
import { getApolloClient } from 'pluto-graphql/apollo/client';
import { PropsWithChildren, useEffect, useState } from 'react';

export const AuthApolloProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { authStoreAccess, signalAuthError } = useAuth();

  const [apolloClient, setApolloClient] = useState<ApolloClient | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!signalAuthError) {
      return;
    }

    const client = getApolloClient({
      getJwtToken: async () => authStoreAccess.getJwtToken(),
      signalAuthError,
    });

    setApolloClient(client.apolloClient);

    return () => {
      void client.dispose();
    };
  }, [authStoreAccess, signalAuthError]);

  if (!apolloClient) {
    return null;
  }

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
